import { actionCreator } from '@blink/components/src/utils';

import {
    GET_COLLATERALS,
    GET_PRICES,
    GET_USER_BORROWS_CLOSED,
    GET_USER_BORROWS_OPENED,
    GET_USER_BORROWS_REGISTERED,
    GET_USER_BORROWS_SUSPENDED,
    RESET_COLLATERALS,
    SET_COLLATERALS,
    SET_PRICES,
    SET_PRICES_LOADING,
    SET_USER_BORROWS_CLOSED,
    SET_USER_BORROWS_MAINTENANCE,
    SET_USER_BORROWS_MAINTENANCE_HISTORY,
    SET_USER_BORROWS_OPENED,
    SET_USER_BORROWS_REGISTERED,
    SET_USER_BORROWS_SUSPENDED,
} from './constants';

import { History, MaintenanceData, Token, UserBorrow } from '@/shared/api/borrow';

export const getUserBorrowsOpenedAction = () => actionCreator(GET_USER_BORROWS_OPENED);
export const setUserBorrowsOpenedAction = (payload: UserBorrow[]) =>
    actionCreator(SET_USER_BORROWS_OPENED, payload);

export const getUserBorrowsSuspendedAction = () => actionCreator(GET_USER_BORROWS_SUSPENDED);
export const setUserBorrowsSuspendedAction = (payload: UserBorrow[]) =>
    actionCreator(SET_USER_BORROWS_SUSPENDED, payload);

export const getUserBorrowsRegisteredAction = () => actionCreator(GET_USER_BORROWS_REGISTERED);
export const setUserBorrowsRegisteredAction = (payload: UserBorrow[]) =>
    actionCreator(SET_USER_BORROWS_REGISTERED, payload);

export const getUserBorrowsClosedAction = () => actionCreator(GET_USER_BORROWS_CLOSED);
export const setUserBorrowsClosedAction = (payload: UserBorrow[]) =>
    actionCreator(SET_USER_BORROWS_CLOSED, payload);

export const setUserBorrowsMaintenanceAction = (payload: MaintenanceData) =>
    actionCreator(SET_USER_BORROWS_MAINTENANCE, payload);

export const setUserBorrowsMaintenanceHistoryAction = (payload: History<MaintenanceData>[]) =>
    actionCreator(SET_USER_BORROWS_MAINTENANCE_HISTORY, payload);

export const getCollaterals = (payload: string) => actionCreator(GET_COLLATERALS, payload);

export const setCollaterals = (payload: Token[]) => actionCreator(SET_COLLATERALS, payload);

export const resetCollaterals = () => actionCreator(RESET_COLLATERALS);

export const getPrices = (payload: { assetsToCollateral: Token[]; leverageAddress: string }) =>
    actionCreator(GET_PRICES, payload);

export const setPricesLoading = (payload: boolean) => actionCreator(SET_PRICES_LOADING, payload);

export const setPrices = (payload: any) => actionCreator(SET_PRICES, payload);
